import React from 'react';

const DynamicCompLoader = ({ dynamicComp }) => {
    const ComponentToRender = require(`${dynamicComp}`).default;
    return(<ComponentToRender />);
}

export default DynamicCompLoader;